import PlaceIcon from '@mui/icons-material/Place';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import './ContactInfo.css';

export const ContactInfo = ({ isMobile = false }: { isMobile?: boolean }) => (
  <div className={`contact-info-bar ${isMobile ? 'contact-info-bar--mobile' : ''}`}>
    <a
      href="https://maps.google.com/?q=Matīsa+iela+46+Rīga"
      target="_blank"
      rel="noopener noreferrer"
      className="contact-info-item"
    >
      <PlaceIcon fontSize="small" />
      <span>Matīsa iela 46, Rīga</span>
    </a>
    <a href="mailto:info@rigadentique.lv" className="contact-info-item">
      <MailOutlineIcon fontSize="small" />
      <span>info@rigadentique.lv</span>
    </a>
    <a href="tel:+37126409932" className="contact-info-item">
      <PhoneIphoneOutlinedIcon fontSize="small" />
      <span>+371 26 409 932</span>
    </a>
  </div>
);
